export * from './src/emails-transmissions-v1-email-transmission-email-transmissions.meta.js';
